<template>
  <div>
    <div class="go-top"
         @click="goUp"
         v-if="showPageUpBtn">
      <div class="a-scrollTop__scrollup">
        <img src="@/assets/img/static/arrow-svg-11-22.svg" alt="">
      </div>
    </div>

    <component :is="layout">
      <router-view/>
    </component>

    <modal v-if="error">
      <template v-slot:header>
        <h5 class="modal-title">{{$t(title)}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeErrorDialog">
          <span aria-hidden="true"><img src="@/assets/img/static/b-icon_close_x.svg" alt=""></span>
        </button>
      </template>

      <template v-slot:body>
        <div class="modal-body__registration">
          <p class="a-formatted-text">{{$t(error)}}</p>
        </div>
      </template>

      <template v-slot:footer>
        <button class="gui-btn gui-btn--red gui-btn--w-140 gui-btn--cancel gui-btn--ep" type="button" data-dismiss="modal" @click="closeErrorDialog" v-t="'buttons.next'"></button>
      </template>
    </modal>

    <extended-modal name="mini-report" :draggable="true" :click-to-close="false">
      Hello world
      <button @click="$modal.hide('mini-report')"></button>
    </extended-modal>

    <confirmation-dialog ref="simple-confirmation" close-on-action></confirmation-dialog>
  </div>
</template>

<script>
  import MainLayout from '@/layouts/MainLayout'
  import _ from "lodash";
  import ConfirmationDialog from "@/components/common/dialogs/ConfirmationDialog";

  export default {
    components: {
      ConfirmationDialog,
      MainLayout
    },

    computed: {
      layout() {
        const layout = _.get(_.findLast(this.$route.matched, 'meta.layout'), 'meta.layout', 'main');
        return layout + '-layout';
      },

      error() {
        return this.$store.getters.globalError instanceof Object ? this.$store.getters.globalError.error : this.$store.getters.globalError;
      },

      title() {
        return _.get(this.$store.getters.globalError, 'title', 'Ошибка');
      },

      showPageUpBtn() {
        return this.scrollPosition > window.innerHeight;
      }
    },

    data: () => ({
      scrollPosition: 0
    }),

    async created() {
      try {
        await this.$store.dispatch('fetchGlobalSettings');
      }
      catch(e) {
        console.error('unable to fetch global settings');
      }

      window.addEventListener('scroll', this.updateScrollPosition);
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.updateScrollPosition);
    },

    methods: {
      closeErrorDialog() {
        this.$store.dispatch('hideGlobalError');
      },

      updateScrollPosition() {
        this.scrollPosition = window.scrollY || window.pageYOffset || 0;
      }
    }
  }
</script>

<style lang="scss">

</style>
